import { For, createMemo } from 'solid-js';
import { textRendersEmpty } from '../canvas/text/BaseTextObject';
import { Object } from '../canvas/Object';
import type { RuntimeObject } from '../types';
import { resolveThemeVar } from './themeVariables';
import { ICanvasPane } from 'Shared/posters/canvas/CanvasWrap';


export function ReadOnlyPosterSvg(P: ICanvasPane)
{
	const canvasCtx = P.canvas;
	const objCtx    = P.objects;
	const dragCtx   = P.drag;

	// A top-level text box that renders to only whitespace is omitted entirely (no diagonal-stripe
	// placeholder) — the same drop a flex container applies to its empty children, generalised to the
	// canvas. Unconditional here: this pane only ever draws read mode, which is user-facing.
	const visibleObjects = createMemo<RuntimeObject[]>(() =>
		objCtx.objects().filter(obj => !textRendersEmpty(obj, P.record))
	);

	// Canvas background: a theme-variable binding replaces the static colour at render time.
	const bgFill = createMemo(() => {
		const v = resolveThemeVar(P.theme, canvasCtx.canvasBindings().background);
		return v !== undefined ? String(v) : canvasCtx.canvasBg();
	});

	const svgStyle = {
		display:          'block',
		'box-shadow':     '0 25px 70px rgba(0,0,0,.8), 0 0 0 1px rgba(255,255,255,.06)',
		'border-radius':  '2px',
		'outline-offset': '3px',
		margin: '0 auto',
		'user-select': 'none'
	};

//NOTE: modeCtx.readOnly ==> use this?
//TODO in time possibly reuse some code between ReadOnlyPosterSvg and EditablePosterSvg

	return (
		<svg
			ref={el => dragCtx?.setSvgRef(el)}
			width={canvasCtx.canvas().width}
			height={canvasCtx.canvas().height}
			viewBox={`0 0 ${canvasCtx.canvas().width} ${canvasCtx.canvas().height}`}
			overflow='hidden'
			style={svgStyle}
		>
			<rect
				x='0' y='0'
				width={canvasCtx.canvas().width}
				height={canvasCtx.canvas().height}
				fill={bgFill()}
			/>

			<g pointer-events='none'>
				<For each={visibleObjects()}>{obj => <Object
					objects={objCtx}
					selection={P.selection}
					history={P.history}
					drag={dragCtx}
					images={P.images}
					upload={P.upload}
					design={P.design}
					record={P.record}
					theme={P.theme}
					textRefs={P.textRefs}
					canvas={canvasCtx.canvas()}
					object={obj}
					mode='read'
				/>}</For>
			</g>
		</svg>
	);
}

